import "core-js/stable";
import "regenerator-runtime/runtime";

import "stylesheets/pages";
import Avatar from "vue-avatar";
import VueSimpleSVG from "vue-simple-svg";
import TurbolinksAdapter from "vue-turbolinks";
import Vue from "vue/dist/vue.esm";
import CurrentDay from "../current_day";
import DateInput from "../date_input";
import Onboarding from "../onboarding/onboarding";
import Slider from "../slider/slider";
import UserMenu from "../user_menu";
import VCalendar from "v-calendar";
import EmailDialog from "../components/email_dialog";
import Notifications from 'vue-notification';
import VueHighlightJS from 'vue-highlightjs';
import 'highlight.js/styles/default.css'; // or other highlight.js theme
import MultipleCodes from "../components/multiple_codes";

// Tell Vue.js to use vue-highlightjs
Vue.use(VueHighlightJS);
Vue.use(TurbolinksAdapter);
Vue.use(VueSimpleSVG);
Vue.use(VCalendar);
Vue.use(Notifications);

Vue.component("avatar", Avatar);
Vue.component("usermenu", UserMenu);
Vue.component("date-input", DateInput);
Vue.component("onboarding", Onboarding);
Vue.component("email-dialog", EmailDialog);
Vue.component("multiple-codes", MultipleCodes);


document.addEventListener("turbolinks:load", () => {
  const app = new Vue({
    el: '[data-behavior="vue"]',
    components: {
      Slider,
      "current-day": CurrentDay,
    },
  });
});
